/*! Wi-images - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var wiImages = {
    init: function () {
        var that = this;
        $(window).on('resize', function () {
            var th = $(this);
            if (th.data('resizeTimeout')) {
                clearTimeout(th.data('resizeTimeout'));
            }
            th.data('resizeTimeout', setTimeout(function () {
                that.gallery.init();
            }, 250));
        });
        that.refresh();
    },
    refresh: function () {
        var that = this;
        setTimeout(function () {
            that.gallery.init();
        }, 250);
    },
    gallery: {
        init: function () {
            var that = this;
            that.lightGallery();
            that.justifiedGallery();
            that.imgHover();
        },
        justifiedGallery: function () {
            document.querySelectorAll('.gallery-justified').forEach(function (gallery) {
                var items = gallery.querySelectorAll(':scope > a');
                if (items.length < 2) return;
                var last = items[items.length - 1];
                var prev = items[items.length - 2];
                last.classList.toggle('jg-orphan', last.offsetTop !== prev.offsetTop);
            });
        },
        lightGallery: function () {
            if ($(".gallery").length) {
                $('.gallery').lightGallery({
                    selector: '.item-picture',
                    exThumbImage: 'data-thumb',
                    thumbnail: false,
                    animateThumb: false,
                    showThumbByDefault: false,
                    download: false,
                    getCaptionFromTitleOrAlt: false
                });
            }
            if ($(".media").length) {
                $('.media').lightGallery({
                    selector: '.lightGallery',
                    thumbnail: true,
                    animateThumb: false,
                    showThumbByDefault: false
                });
            }
        },
        imgHover: function () {
            if ($('.img-hover').length) {
                $('.img-hover').each(function () {
                    var src = $(this).attr('data-hover');
                    var classes = $(this).attr('class');
                    $('<img src="' + src + '" class="' + classes + ' img-hover-hiden"/>').insertAfter($(this));
                });
                $('.image').hover(function () {
                    $(this).find(".img-hover-hiden").fadeToggle();
                });
            }
        }
    },
    objectFit: function () {
        if ('objectFit' in document.documentElement.style === false) {
            $('img').each(function () {
                var img = $(this);
            });
        }
    }
};

$(function () {
    wiImages.init();
});
